// src/components/VisitorTracking/VisitorTracking.jsx

import React from "react";

import useVisitorTracking from "../../hooks/useVisitorTracking";

/**
 * Composant global chargé uniquement pour effectuer
 * le suivi anonyme de navigation.
 *
 * Il n'affiche aucun élément dans la page.
 */
export default function VisitorTracking() {
  useVisitorTracking({
    enabled: true,

    heartbeatIntervalMs:
      25000,

    /**
     * Ces routes ne doivent pas apparaître dans les
     * statistiques commerciales.
     *
     * Adapte éventuellement cette liste aux routes réelles
     * de ton projet.
     */
    excludedPathPrefixes: [
      "/appli",
      "/admin",
      "/dashboard",
    ],
  });

  return null;
}